import "./topbar.scss";
import { Person } from "@mui/icons-material";

export default function Topbar({ menuOpen, setMenuOpen }) {

  const changeBackg = ()=>{
    console.log(window.scrollY);
  }
  window.addEventListener('scroll', changeBackg)
  return (
    <div className={"topbar " + (menuOpen && "active") }>
      <div className="wrapper">
        <div className="left">
          <a href="#intro" className="logo">
         <img src="assets/logo.jpg" alt="" />
          </a>
          <div className="itemContainer">
            <Person className="icon" />
            <span>+855 968 070 983</span>
          </div>
        </div>
        <div className="right">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
